<template>
    <div class="btn-toolbar" role="toolbar" :aria-label="label">
        <slot></slot>
    </div>
</template>
<script charset="utf-8">
    export default {
        name: "ButtonToolbar"
    }
</script>